import Home from './pages/home/Home';
import Routes from './pages/Routes';
import Resume from './pages/resume/Resume';

import XmasCard2023 from '../_archived/other/XmasCard2023';

import Exports from './pages/exports/Exports';
import DateTime from './pages/DateTime';

const routes = [
  { path: '/', element: <Home />, },
  { path: '/exports', element: <Exports />, },
  { path: '/_routes', element: <Routes />, },
  { path: '/', element: <Routes />, },

  { path: 'cv', element: <Resume lang="fr" /> },
  { path: 'cv/imprimable', element: <Resume lang="fr" mode="print" hideWave /> },
  { path: 'resume', element: <Resume /> },
  { path: 'resume/print', element: <Resume mode="print" hideWave /> },
  { path: 'resume/full', element: <Resume mode="full" hideWave /> },

  // Special Routes
  { path: '/xmas-card-2023', element: <XmasCard2023 /> },
  { path: '/_datetime', element: <DateTime /> },

];

export default routes;
